import { JsonObject, JsonProperty } from 'json2typescript';

import { PBCRelationInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PBCRelation')
export class PBCRelation implements PBCRelationInterface {
    @JsonProperty('nombre', StringAdapter)
    private _name: string = undefined;

    @JsonProperty('tipo', StringAdapter)
    private _type: string = undefined;

    get name(): string {
        return this._name;
    }

    get type(): string {
        return this._type;
    }
}
